import axios from "axios";
import { GET_LEARNING_TASK_LIST } from ".";
import { serverUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";

export const getLearningTask = () => {
    return (dispatch) => {
      return axios
        .get(serverUrl.Learning)
        .then((response) => {
          dispatch({
            type: GET_LEARNING_TASK_LIST,
            payload: response.data.task_list,
          });
          
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          console.log(error);
        });
    };
  };